// extracted by mini-css-extract-plugin
export var button = "_eb-0";
export var donut = "_eb-1";
export var donutFill = "_eb-3";
export var donutTrack = "_eb-2";